import { FC } from "react";
import "./style.css";

interface Props {
  error: string | undefined;
}

export const ErrorMessage: FC<Props> = ({ error }) => {
  if (!error) {
    return null;
  }

  return <p className="error-text">{error}</p>;
};
